import { uploadPharmacyMedia } from "../../reducer/uploadPharmacyMedia/uploadPharmacyMediaReducer";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

const uploadPharmacyMediaSlice = createSlice({
  name: "uploadPharmacyMedia",
  initialState,
  reducers: {
    resetPharmacyMediaState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload Doctor Media
      .addCase(uploadPharmacyMedia.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadPharmacyMedia.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(uploadPharmacyMedia.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Upload Avatar
    //   .addCase(uploadAvatar.pending, (state) => {
    //     state.isLoading = true;
    //     state.error = null;
    //   })
    //   .addCase(uploadAvatar.fulfilled, (state, action) => {
    //     state.isLoading = false;
    //     state.data = action.payload;
    //   })
    //   .addCase(uploadAvatar.rejected, (state, action) => {
    //     state.isLoading = false;
    //     state.error = action.payload;
    //   });
  },
});

export const { resetPharmacyMediaState } = uploadPharmacyMediaSlice.actions;
export default uploadPharmacyMediaSlice.reducer;
